import { useState, useCallback, useRef, useEffect } from "react";

// Text flows directly as chunks arrive from the SSE stream — no artificial throttle.
// The backend already buffers at word boundaries, so updates feel natural.

export function useAssistantStreaming() {
  const [streamingContent, setStreamingContent] = useState("");
  const [isStreaming, setIsStreaming]            = useState(false);

  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  const startStream = useCallback(() => {
    if (mountedRef.current) {
      setStreamingContent("");
      setIsStreaming(true);
    }
  }, []);

  const appendChunk = useCallback((text) => {
    if (mountedRef.current) {
      setStreamingContent((prev) => prev + text);
    }
  }, []);

  const finalizeStream = useCallback(() => {
    if (mountedRef.current) {
      setStreamingContent("");
      setIsStreaming(false);
    }
  }, []);

  const cancelStream = useCallback(() => {
    if (mountedRef.current) {
      setStreamingContent("");
      setIsStreaming(false);
    }
  }, []);

  return {
    streamingContent,
    isStreaming,
    startStream,
    appendChunk,
    finalizeStream,
    cancelStream,
  };
}
